module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "新增参展品牌",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      }
    }
  }, [_c('el-form', {
    staticStyle: {
      "display": "flex",
      "height": "36px",
      "margin-top": "-20px",
      "margin-bottom": "6px"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "display": "flex"
    },
    attrs: {
      "label": "品牌名称："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入品牌名称",
      "maxlength": "20"
    },
    model: {
      value: (_vm.filters.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyWord", $$v)
      },
      expression: "filters.keyWord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "100%"
    },
    attrs: {
      "label": "品类："
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.brandTypeId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "brandTypeId", $$v)
      },
      expression: "filters.brandTypeId"
    }
  }, _vm._l((_vm.brandTypearr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "margin-right": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("查 询")])], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticClass: "ban_tab",
    staticStyle: {
      "height": "auto",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.brandList,
      "row-key": _vm.getRowKeys,
      "stripe": "",
      "border": "",
      "header-cell-style": {
        background: '#bbbbbb'
      }
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "reserve-selection": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          attrs: {
            "title": scope.row.Name
          }
        }, [_vm._v(" " + _vm._s(scope.row.Name) + " ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin": "10px 0"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total,
      "current-page": _vm.pageIndex
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.dataFormSubmit()
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46f62576!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/addExhibitorsBrand.vue
// module id = 1685
// module chunks = 3